import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { VisibilitySwitch } from "@common/visibilitySwitch";
import { Props } from "./types";
import { BinIcon } from "./binIcon";
import { EditIcon } from "./editIcon";
import { MenuIcon } from "./menuIcon";
import { TransferIcon } from "./transferIcon";
import styles from "./styles.scss";

function ContextualMenu(props: Props) {
  const { t } = useTranslation();

  return (
    <VisibilitySwitch
      renderChildren={(isVisible, show, hide) => (
        <div
          className={classNames(styles.contextualMenu, {
            [styles.openedMenu]: isVisible,
          })}
          onMouseEnter={show}
          onMouseLeave={hide}
        >
          <MenuIcon className={styles.menuIcon} />
          {isVisible && (
            <div className={styles.menu}>
              <div className={styles.menuItem} onClick={props.transfer}>
                <TransferIcon className={styles.icon} />
                <p>{t("zone.transfer")}</p>
              </div>
              <div className={styles.menuItem} onClick={props.edit}>
                <EditIcon className={styles.icon} />
                <p>{t("zone.edit")}</p>
              </div>
              <div
                className={classNames(styles.menuItem, styles.removeAction)}
                onClick={props.remove}
              >
                <BinIcon className={styles.icon} />
                <p>{t("zone.remove")}</p>
              </div>
            </div>
          )}
        </div>
      )}
    />
  );
}

export { ContextualMenu };
